import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { useRecoilState } from "recoil"
import { ShowHeader } from "../../states/showHeader"
import { Button, Box, Container, Grid, Image, Typography } from "src/UILibrary"
import { Title } from "src/components/layout/Title"
import { OutlinedButton } from "src/components/buttons/OutlinedButton"
import { FaqItem } from "./components/FaqItem"
import { QuestionItem } from "./components/QuestionItem"
import { AnswerItem } from "./components/AnswerItem"
import { ShowToast } from "src/states/showToast"
import { Faq, FaqService } from "src/openapi"
import { RESPONSE_CODE, SNACKBAR_TYPES } from "src/modules/const"
import "src/styles/common.scss"
import { useNavigate } from "react-router-dom"
import { OfficeItem } from "../top/components/OfficeItem"

const PAGE_SIZE = 5

export const FaqPage = () => {
  const { t } = useTranslation("translation", { keyPrefix: "faq" })

  const [, setShowHeader] = useRecoilState(ShowHeader)
  const [, setShowToast] = useRecoilState(ShowToast)

  const isTablet = useMediaQuery({ query: "(min-width: 900px)" })
  const [pageLoad, setPageLoad] = useState<boolean>(false)
  const [end, setEnd] = useState<boolean>(false)
  const [faqs, setFAQs] = useState<Faq[]>([])
  const isPC = useMediaQuery({ query: "(min-width: 1050px)" })

  const navigate = useNavigate()

  const handleGetFAQs = () => {
    FaqService.faqList(faqs.length, PAGE_SIZE)
      .then((res) => {
        if (res.status === RESPONSE_CODE.SUCCESS) {
          if (
            (res.data?.faqs as Faq[]).length === 0 ||
            (res.data?.faqs as Faq[]).length < PAGE_SIZE
          ) {
            setEnd(true)
          }
          setFAQs([...faqs, ...(res.data?.faqs as Faq[])])
        } else {
          setShowToast({ show: true, text: t("failed_list"), type: SNACKBAR_TYPES.ERROR })
        }
      })
      .catch(() => {
        setShowToast({ show: true, text: t("failed_list"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  useEffect(() => {
    setShowHeader(true)
    if (pageLoad) {
      return
    }
    setPageLoad(true)
    handleGetFAQs()
  })

  return (
    <>
      <Title title={t("faq_title")} sub_title={t("faq_sub_title")} />
      {isTablet ? (
        <Box
          mt={0}
          pt={0}
          pb={0}
          sx={{
            backgroundImage: `url(${process.env.REACT_APP_S3_URL}facility.jpg)`,
            backgroundPosition: "center",
          }}
        >
          <Grid container>
            <Grid item xs={6} md={4}>
              <Box color="info.contrastText" p={0}>
                <FaqItem image="" color="white" opacity={0.7} />
              </Box>
            </Grid>
            <Grid item xs={6} md={4}>
              <Box color="info.contrastText" p={0}>
                <FaqItem image="" color="white" opacity={0} />
              </Box>
            </Grid>
            <Grid item xs={6} md={4}>
              <Box color="info.contrastText" p={0}>
                <FaqItem image="" color="white" opacity={0.7} />
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box
          mt={0}
          pt={0}
          pb={0}
          sx={{
            backgroundImage: `url(${process.env.REACT_APP_S3_URL}facility.jpg)`,
            backgroundPosition: "center",
          }}
        >
          <Box color="info.contrastText" p={0}>
            <FaqItem image="" color="white" opacity={0} />
          </Box>
        </Box>
      )}

      <Container maxWidth="md" sx={{ px: "0px", py: "20px", mb: "0px" }}>
        {faqs.map((faq, index) => {
          return (
            <>
              <QuestionItem key={`question_${index}`} question={faq.question ? faq.question : ""} />
              <AnswerItem key={`answer_${index}`} answer={faq.answer ? faq.answer : ""} />
            </>
          )
        })}

        <Box className="box_show_more">
          {end ? (
            <></>
          ) : (
            <OutlinedButton caption={t("show_more")} onClick={() => handleGetFAQs()} />
          )}
        </Box>
      </Container>
      <Box
        sx={{
          mt: "0px",
          pt: "0px",
          pb: "0px",
        }}
        bgcolor="background.body"
        component="form"
        autoComplete="off"
      >
        {/* <Container maxWidth="md" sx={{ mx: "auto", mb: "100px", px: "0px !important" }}>
          <Box sx={{}}>
            <FacilityMapItem
              name="高岡まちなかスタートアップ支援施設"
              number="〒933-0029"
              address="富山県高岡市御旅屋町101番地"
              tel="00-0000-0000"
              time="営業時間 9:00~20:00 土日祝休"
              support_time="(平日) 13時00分~21時00分 (土日祝日) 10時00分~18時00分"
              community_time="(全日) 10時00分~21時00分"
            />
          </Box>
        </Container> */}
        <Container
          maxWidth="lg"
          sx={isPC ? { p: "20px 10px", mb: "0px" } : { py: "10px", mb: "0px" }}
        >
          <Box mt="0px">
            <Container maxWidth="md" sx={{ mx: "auto", my: "20px", px: "0px !important" }}>
              <OfficeItem
                title="高岡まちなかスタートアップ支援施設「TASU」"
                address="富山県高岡市御旅屋町101番地 御旅屋セリオ４階"
                operatingTime="（平日）13:00～21:00（土日祝日）10:00～18:00"
                breakTime="毎週水曜日（祝日の場合は翌日）、年末年始"
                support="常時2名以上の体制で、起業・創業から事業承継まで、幅広く相談ができます。"
                mapURL="https://maps.google.com/maps?q=36.7455433,137.0139992&hl=ja&z=14&output=embed"
              />
            </Container>
          </Box>
        </Container>
      </Box>

      <Box
        sx={{
          py: "40px",
          position: "relative",
          background:
            "linear-gradient(99.46deg, rgba(15, 124, 158, 0.6) -0.55%, rgba(14, 140, 80, 0.6) 100%)",
        }}
        className="main-body-with-footer"
      >
        <Image
          src={`${process.env.REACT_APP_S3_URL}bg_1.jpeg`}
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: -1,
            height: "100%",
            width: "100%",
          }}
          imageStyle={{
            height: "100%",
            width: "100%",
          }}
        />
        <Box className="box_contact_us" sx={{ mb: "35px" }}>
          <Box display="block" sx={{ textAlign: "center" }}>
            <Typography.Large className="title_contact_us">{t("contact_title")}</Typography.Large>
            <Button
              variant="contained"
              className="button_contact_us"
              onClick={() => navigate("/contact")}
              sx={{
                ":hover": {
                  bgcolor: "#2DA389",
                },
              }}
            >
              {t("contactus_form")}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  )
}
